import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type FeesAppRuleState = {
    ruleTabs: RuleTab[];
    currentTab: string;
};

type RuleTab = {
    key: string;
    display: string;
};

const baseSessionState = {
    ruleTabs: [],
    currentTab: 'rules',
} as FeesAppRuleState;

const slice = createSlice({
    name: 'feesAppRules',
    initialState: baseSessionState,
    reducers: {
        addRuleTab: (state, action: PayloadAction<RuleTab>) => {
            state.ruleTabs.push(action.payload);
        },
        removeRuleTab: (state, action) => {
            state.ruleTabs = state.ruleTabs.filter(
                (x) => x.key !== action.payload
            );
        },
        setCurrentTab: (state, action: PayloadAction<string>) => {
            state.currentTab = action.payload;
        },
    },
});

export const {addRuleTab, removeRuleTab, setCurrentTab} = slice.actions;

export default slice.reducer;
